import {Component, ElementRef, ViewChild} from '@angular/core';
import { NavController, NavParams, Content, ModalController, AlertController, ActionSheetController } from 'ionic-angular';
import { DataProvider } from '../../providers/data';
import { ImageProvider } from '../../providers/image';
import { LoadingProvider } from '../../providers/loading';
import { UserProvider } from '../../providers/user';
import { PhotoLibrary } from '@ionic-native/photo-library';
import {TeamappProvider} from '../../providers/teamapp';

import { Camera } from '@ionic-native/camera';
import { Contacts } from '@ionic-native/contacts';
import { Keyboard } from '@ionic-native/keyboard';
import { Geolocation } from '@ionic-native/geolocation';
import { GroupInfoPage } from '../group-info/group-info';
import { UserInfoPage } from '../user-info/user-info';
import { ImageModalPage } from '../image-modal/image-modal';
@Component({
  selector: 'page-group',
  templateUrl: 'group.html'
})
export class GroupPage {
  @ViewChild(Content) content: Content;
  @ViewChild('myInput') myInput: ElementRef;
  private title: any;
  private image: any;
  private groupId: any;
  private message: any;
  private messages: any;
  private updateDateTime: any;
  private subscription: any;
  private messagesToShow: any;
  private startIndex: any = -1;
  private scrollDirection: any = 'bottom';
  // Set number of messages to show.
  private numberOfMessages = 10;
  // GroupPage
  // This is the page where the user can chat with other group members and view group info.
  constructor(public teamappProvider: TeamappProvider, private photoLibrary: PhotoLibrary, public navCtrl: NavController, public navParams: NavParams, public dataProvider: DataProvider,
    public modalCtrl: ModalController, public alertCtrl: AlertController,
    public imageProvider: ImageProvider, public loadingProvider: LoadingProvider, public camera: Camera, public keyboard: Keyboard, public actionSheet: ActionSheetController,
    public contacts: Contacts, public geolocation: Geolocation, public userProvider: UserProvider) { }

  ionViewDidLoad() {
    // Get group details
    this.groupId = this.navParams.get('groupId');
    this.subscription = this.dataProvider.getGroup(this.groupId).snapshotChanges().subscribe((group) => {

      if (group.payload.exists()) {
        this.title = group.payload.val().name;
        this.image = group.payload.val().img;
        // Get group messages
        this.dataProvider.getGroupMessages(group.key).snapshotChanges().subscribe((messagesRes) => {
          let messages = messagesRes.payload.val();
          if(messages == null || messages == undefined) messages = [];

          console.log(this.messages);
          if (this.messages != null && this.messages != undefined) {
            // Just append newly added messages to the bottom of the view.
            
            if (messages.length > this.messages.length) {
              let message = messages[messages.length - 1];
              this.dataProvider.getUser(message.sender).snapshotChanges().subscribe((user) => {
                  let u = user.payload.val();
                  message.avatar = u.img;
                  message.user_name = u.name;
                  message.user_surname = u.surname;
              });
              this.messages.push(message);
              // Also append to messagesToShow.
              this.messagesToShow.push(message);
              // Reset scrollDirection to bottom.
              this.scrollDirection = 'bottom';
            }
          } else {
            // Get all messages, this will be used as reference object for messagesToShow.
            this.messages = [];
            messages.forEach((message) => {
              console.log(message)
              this.dataProvider.getUser(message.sender).snapshotChanges().subscribe((user) => {
                if(user.key != null){
                  let u = user.payload.val();
                  message.avatar = u.img;
                  message.user_name = u.name;
                  message.user_surname = u.surname;
                }
              });
              this.messages.push(message);
            });
            // Load messages in relation to numOfMessages.
            if (this.startIndex == -1) {
              // Get initial index for numberOfMessages to show.
              if ((this.messages.length - this.numberOfMessages) > 0) {
                this.startIndex = this.messages.length - this.numberOfMessages;
              } else {
                this.startIndex = 0;
              }
            }
            if (!this.messagesToShow) {
              this.messagesToShow = [];
            }
            // Set messagesToShow
            for (var i = this.startIndex; i < this.messages.length; i++) {
              this.messagesToShow.push(this.messages[i]);
            }
            this.loadingProvider.hide();
            this.scrollBottom();
            this.setMessagesRead(this.messages);
          }
        });
      }
    });

    // Update messages' date time elapsed every minute based on Moment.js.
    var that = this;
    if (!that.updateDateTime) {
      that.updateDateTime = setInterval(function() {
        if (that.messages) {
          that.messages.forEach((message) => {
            let date = message.date;
            message.date = new Date(date);
          });
        }
      }, 60000);
    }
  }

  // Load previous messages in relation to numberOfMessages.
  loadPreviousMessages() {
    var that = this;
    // Show loading.
    this.loadingProvider.show();
    setTimeout(function() {
      // Set startIndex to load more messages.
      if (that.startIndex - that.numberOfMessages > -1) {
        that.startIndex -= that.numberOfMessages;
      } else {
        that.startIndex = 0;
      }
      // Refresh our messages list.
      that.messages = null;
      that.messagesToShow = null;
      // Set scroll direction to top.
      that.scrollDirection = 'top';
      // Populate list again.
      that.ionViewDidLoad();
    }, 1000);
  }

  // Update messagesRead when user lefts this page.
  ionViewWillLeave() {
    if (this.messages)
      this.setMessagesRead(this.messages);
  }

  // Check if currentPage is active, then update user's messagesRead.
  setMessagesRead(messages) {
    if (this.navCtrl.getActive().instance instanceof GroupPage) {
      // Update user's messagesRead on database.

    }
  }

  // Check if 'return' button is pressed and send the message.
  onType(keyCode) {
    if (keyCode == 13) {
      // this.keyboard.close();
      // this.send();
    }
  }

  // Scroll to bottom of page after a short delay.
  scrollBottom() {
    var that = this;
    setTimeout(function() {
      that.content.scrollToBottom();
    }, 300);
  }

  // Scroll to top of the page after a short delay.
  scrollTop() {
    var that = this;
    setTimeout(function() {
      that.content.scrollToTop();
    }, 300);
  }

  // Scroll depending on the direction.
  doScroll() {
    if (this.scrollDirection == 'bottom') {
      this.scrollBottom();
    } else if (this.scrollDirection == 'top') {
      this.scrollTop();
    }
  }

  // Check if the user is the sender of the message.
  isSender(message) {
    if (message.sender == this.userProvider.getUserID()) {
      return true;
    } else {
      return false;
    }
  }

  // Check if the message is a system message.
  isSystemMessage(message) {
    if (message.type == 'system') {
      return true;
    } else {
      return false;
    }
  }

  // View user info
  viewUser(userId) {
    this.navCtrl.push(UserInfoPage, { userId: userId });
  }

  // Send text message to the group.
  send(type) {
    // Clone an instance of messages object so it will not directly be updated.
    // The messages object should be updated by our observer declared on ionViewDidLoad.
    let messages = JSON.parse(JSON.stringify(this.messages));
    
    messages.push({
      date: new Date().toString(),
      sender: this.userProvider.getUserID(),
      type: type,
      message: this.message
    });

    // Update group messages.
    this.dataProvider.getGroup(this.groupId).update({
      messages: messages
    });
    // Clear messagebox.
    this.message = '';
  }

  // Enlarge image messages.
  enlargeImage(img) {
    let imageModal = this.modalCtrl.create(ImageModalPage, { img: img });
    imageModal.present();
  }

  attach(){
    let action = this.actionSheet.create({
      title:'Anhang wählen',
      buttons:[{
        text: 'Kamera',
        handler: () =>{
          console.log("take photo");
          this.imageProvider.uploadGroupPhotoMessage(this.groupId, this.camera.PictureSourceType.CAMERA).then((url) => {
            // Process image message.
            this.sendPhotoMessage(url);
          });
        }
      }, {
        text: 'Galerie',
        handler: ()=>{
          console.log("Access gallery");
          this.imageProvider.uploadGroupPhotoMessage(this.groupId, this.camera.PictureSourceType.PHOTOLIBRARY).then((url) => {
              // Process image message.
              this.sendPhotoMessage(url);
          });
        }
      },{
        text: 'Video',
        handler: () =>{
          console.log("Video");
          this.imageProvider.uploadGroupVideoMessage(this.groupId).then(url=>{
            this.sendVideoMessage(url);
          });
        }
      },{
        text: 'Standort',
        handler:()=>{
          console.log("Location");
          this.geolocation.getCurrentPosition({
            timeout: 2000
          }).then(res => {
            let locationMessage = "Standort: lat:"+res.coords.latitude+" lng:"+res.coords.longitude;
            let mapUrl="<a href='https://www.google.com/maps/search/"+res.coords.latitude+","+res.coords.longitude+"'>Auf Maps anzeigen</a>";
            let confirm = this.alertCtrl.create({
              title: 'Standort',
              message: locationMessage,
              buttons:[{
                text:'Abbrechen',
                handler: () =>{
                  console.log("canceled");
                }
              },{
                text: 'Teilen',
                handler: () =>{
                  console.log("share");
                  this.message = locationMessage+"<br>"+mapUrl;
                  this.send('location');
                }
              }]
            });
            confirm.present();
          }, locationErr => {
            console.log("Location Error"+ JSON.stringify(locationErr));
          });
        }
      },{
        text: 'Kontakt',
        handler: () =>{
          console.log("Share contact");
          this.contacts.pickContact().then( data =>{
            console.log(data.displayName);
            console.log(data.phoneNumbers[0].value);
            this.message = "<b>Name:</b> "+data.displayName+"<br><b>Mobil:</b> <a href='tel:"+data.phoneNumbers[0].value+"'>"+data.phoneNumbers[0].value+"</a>";
            this.send('contact');
          }, err=>{
            console.log(err);
          })
        }
      },{
        text: 'Abbrechen',
        role: 'cancel',
        handler: ()=>{
          console.log("cancelled");
        }
      }]
    });
    action.present();
  }
  takePhoto(){
    this.imageProvider.uploadGroupPhotoMessage(this.groupId, this.camera.PictureSourceType.CAMERA).then((url) => {
      // Process image message.
      this.sendPhotoMessage(url);
    });
  }

  // Process photoMessage on database.
  sendPhotoMessage(url) {
    let messages = JSON.parse(JSON.stringify(this.messages));
    messages.push({
      date: new Date().toString(),
      sender: this.userProvider.getUserID(),
      type: 'image',
      url: url
    });
    this.dataProvider.getGroup(this.groupId).update({
      messages: messages
    });
    this.message = '';
  }

  sendVideoMessage(url) {
    let messages = JSON.parse(JSON.stringify(this.messages));
    messages.push({
      date: new Date().toString(),
      sender: this.userProvider.getUserID(),
      type: 'video',
      url: url
    });
    this.dataProvider.getGroup(this.groupId).update({
      messages: messages
    });
    this.message = '';
  }

  // View group info.
  groupInfo() {
    this.navCtrl.push(GroupInfoPage, { groupId: this.groupId });
  }

  messageMenu(menu: any, isother:boolean) {
    if(isother == false) {
      if(menu.type == 'text') {
        const actionSheet = this.actionSheet.create({
          title: 'Nachricht',
          buttons: [
            {
              text: 'Löschen',
              handler: () => {
                let key = this.getMessageKey(menu);
                let keyShow = this.getMessageToShowKey(menu);
                console.log("normal=>"+key);
                console.log("show => "+keyShow);

                if(key != -1) {
                  let msgPayload = this.messages[key];
                  msgPayload.type = 'deleted'
                  this.messages[key] = msgPayload;
                  this.messagesToShow[keyShow] = msgPayload;

                }

              }
            },
            {
              text: 'Abbrechen',
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        actionSheet.present();
      } else if(menu.type=='image') {
        const actionSheet = this.actionSheet.create({
          title: 'Nachricht',
          buttons: [
            {
              text: 'Löschen',
              handler: () => {
                let key = this.getMessageKey(menu);
                let keyShow = this.getMessageToShowKey(menu);
                console.log("normal=>"+key);
                console.log("show => "+keyShow);

                if(key != -1) {
                  let msgPayload = this.messages[key];
                  msgPayload.type = 'deleted'
                  this.messages[key] = msgPayload;
                  this.messagesToShow[keyShow] = msgPayload;
                }

              }
            },
            {
              text: 'In Galerie speichern',
              handler: () => {
                this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                  let urlEncrypt = btoa(unescape(encodeURIComponent(menu.message)));
                  console.log(urlEncrypt);
                  this.teamappProvider.http_request('action=generate_download_link&url='+urlEncrypt, 'gallery', false, true).then(data => {
                    let download: any = data;
                    console.log(download);
                    this.photoLibrary.saveImage(download.download_url, 'teamapp');
                  });
                  /**/
                })
                    .catch(err => console.log('permissions weren\'t granted'));

              }
            },
            {
              text: 'Abbrechen',
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        actionSheet.present();
      } else if(menu.type=='video') {
        const actionSheet = this.actionSheet.create({
          title: 'Nachricht',
          buttons: [
            {
              text: 'Löschen',
              handler: () => {
                let key = this.getMessageKey(menu);
                let keyShow = this.getMessageToShowKey(menu);
                console.log("normal=>"+key);
                console.log("show => "+keyShow);

                if(key != -1) {
                  let msgPayload = this.messages[key];
                  msgPayload.type = 'deleted'
                  this.messages[key] = msgPayload;
                  this.messagesToShow[keyShow] = msgPayload;

                }

              }
            },
            {
              text: 'In Galerie speichern',
              handler: () => {
                this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                  let urlEncrypt = btoa(unescape(encodeURIComponent(menu.message)));
                  console.log(urlEncrypt);
                  this.teamappProvider.http_request('action=generate_download_link_video&url='+urlEncrypt, 'gallery', false, true).then(data => {
                    let download: any = data;
                    console.log(download);
                    this.photoLibrary.saveVideo(download.download_url, 'teamapp');
                  });
                  /**/
                })
                    .catch(err => console.log('permissions weren\'t granted'));

              }
            },
            {
              text: 'Abbrechen',
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        actionSheet.present();
      }
    } else {
      if(menu.type == 'text') {
        const actionSheet = this.actionSheet.create({
          title: 'Nachricht',
          buttons: [
            {
              text: 'Löschen',
              handler: () => {
                let key = this.getMessageKey(menu);
                let keyShow = this.getMessageToShowKey(menu);
                console.log("normal=>"+key);
                console.log("show => "+keyShow);

                if(key != -1) {
                  let msgPayload = this.messages[key];
                  msgPayload.type = 'deleted'
                  this.messages[key] = msgPayload;
                  this.messagesToShow[keyShow] = msgPayload;

                }

              }
            },
            {
              text: 'Abbrechen',
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        actionSheet.present();
      } else if(menu.type=='image') {
        const actionSheet = this.actionSheet.create({
          title: 'Nachricht',
          buttons: [
            {
              text: 'In Galerie speichern',
              handler: () => {
                this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                  let urlEncrypt = btoa(unescape(encodeURIComponent(menu.message)));
                  console.log(urlEncrypt);
                  this.teamappProvider.http_request('action=generate_download_link&url='+urlEncrypt, 'gallery', false, true).then(data => {
                    let download: any = data;
                    console.log(download);
                    this.photoLibrary.saveImage(download.download_url, 'teamapp');
                  });
                  /**/
                })
                    .catch(err => console.log('permissions weren\'t granted'));

              }
            },
            {
              text: 'Abbrechen',
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        actionSheet.present();
      } else if(menu.type=='video') {
        const actionSheet = this.actionSheet.create({
          title: 'Nachricht',
          buttons: [
            {
              text: 'In Galerie speichern',
              handler: () => {
                this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                  let urlEncrypt = btoa(unescape(encodeURIComponent(menu.message)));
                  console.log(urlEncrypt);
                  this.teamappProvider.http_request('action=generate_download_link_video&url='+urlEncrypt, 'gallery', false, true).then(data => {
                    let download: any = data;
                    console.log(download);
                    this.photoLibrary.saveVideo(download.download_url, 'teamapp');
                  });
                  /**/
                })
                    .catch(err => console.log('permissions weren\'t granted'));

              }
            },
            {
              text: 'Abbrechen',
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        actionSheet.present();
      }
    }
  }

  getMessageKey(message:any) {
    console.log(this.messages);
    for(let i=0; i<this.messages.length;i++) {
      if(this.messages[i].message === message.message && message.date === this.messages[i].date) {
        return i;
      }
    }
    return -1;
  }


  getMessageToShowKey(message:any) {
    for(let i=0; i<this.messagesToShow.length;i++) {
      if(this.messagesToShow[i].message === message.message && message.date === this.messagesToShow[i].date) {
        return i;
      }
    }
    return -1;
  }

  resize() {
    var element = this.myInput['_elementRef'].nativeElement.getElementsByClassName("text-input")[0];
    var scrollHeight = element.scrollHeight;
    element.style.height = scrollHeight + 'px';
    this.myInput['_elementRef'].nativeElement.style.height = (scrollHeight + 20) + 'px';
  }
}



// WEBPACK FOOTER //
// ./src/pages/group/group.ts